import { useCallback, useState } from 'react';

import { type FilterValue, type SorterResult } from 'antd/lib/table/interface';
import { type Role } from 'models/user';

import { type DataType } from './columns';

export interface FiltersState {
  searchString: string;
  searchStringQuery: string;
  filterInfo: Record<string, FilterValue | null>;
  sort: SorterResult<DataType>;
}

export interface FiltersActions {
  setSort: React.Dispatch<React.SetStateAction<SorterResult<DataType>>>;
  setFilterInfo: React.Dispatch<React.SetStateAction<Record<string, FilterValue | null>>>;
  setSearchString: React.Dispatch<React.SetStateAction<string>>;
  setSearchFilter: () => void;
  clearFilters: () => void;
}

interface Options {
  defaultRoles?: Role[];
}

export const useFilters = (options?: Options): { filters: FiltersState; actions: FiltersActions } => {
  const [searchString, setSearchString] = useState('');
  const [searchStringQuery, setSearchStringQuery] = useState('');
  const [filterInfo, setFilterInfo] = useState<Record<string, FilterValue | null>>({
    isActive: ['ACTIVE'],
    role: options?.defaultRoles || null,
  });
  const [sort, setSort] = useState<SorterResult<DataType>>({});

  const clearFilters = useCallback(() => {
    setSort({});
    setFilterInfo({ role: options?.defaultRoles || null, isActive: ['ACTIVE'] });
    setSearchStringQuery('');
    setSearchString('');
  }, []);

  const setSearchFilter = useCallback(() => {
    setSearchStringQuery(searchString);
  }, [searchString]);

  return {
    filters: {
      searchString,
      searchStringQuery,
      filterInfo,
      sort,
    },
    actions: {
      setSort,
      setFilterInfo,
      setSearchString,
      setSearchFilter,
      clearFilters,
    },
  };
};
